import { render, staticRenderFns } from "./Resulting.vue?vue&type=template&id=31704969"
import script from "./Resulting.vue?vue&type=script&lang=js"
export * from "./Resulting.vue?vue&type=script&lang=js"
import style0 from "./Resulting.vue?vue&type=style&index=0&id=31704969&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports